import { pageAssets } from './pageAssets';
export const CHECKOUT_URL = 'https://badminton-class-ready.impultienda.ar/checkout';
export const STORE_URL = 'https://badminton-class-ready.impultienda.ar';
export const TERMS_URL = 'https://badminton-class-ready.impultienda.ar/#impu-legal-terms';
export const PRIVACY_URL = 'https://badminton-class-ready.impultienda.ar/#impu-legal-privacy';
export const SUPPORT_EMAIL = 'support@stockdigital.shop';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const OFFER_ANCHOR = '#offer-details';

export const COVER_IMAGE = pageAssets['1'];
export const BOX_MOCKUP = 'https://cdn.magicpatterns.com/uploads/iEjjQY36J7YokquNKGYrLf/img_bad_1.png';
export const BOX_MOCKUP_ALT =
  'Badminton Class Ready digital teaching pack: the 12 complete beginner lessons guide with its 5 bonus resources';

export const DELIVERY_NOTE = 'Your download links are emailed after payment is approved.';
export const CHECKOUT_NOTE = 'Secure checkout. Final payment methods and currency are shown at checkout.';
export const PRICE_CURRENCY_NOTE = 'Prices shown in USD. The final total is shown at checkout.';

export const heroInclusions = ['Ready-to-teach lessons', 'Reuse every year', '5 bonuses', 'Ages 9–12'];

export const heroTrust: { icon: 'lock' | 'mail' | 'shield'; label: string }[] = [
  { icon: 'lock', label: 'Secure checkout' },
  { icon: 'mail', label: 'Download links by email' },
  { icon: 'shield', label: 'One-time purchase' },
];

export const trustStrip = [
  { value: 'PDF', label: 'Digital format' },
  { value: 'Email', label: 'Download links' },
  { value: 'One-time', label: '$27 USD payment' },
  { value: '5 bonuses', label: 'Included in your pack' },
];

export const solutionStats = [
  { value: '12', label: 'Complete lessons' },
  { value: '40', label: 'Visual PDF pages' },
  { value: '40', label: 'Minutes per lesson' },
  { value: '5', label: 'Bonus resources' },
];

export const coreGuideFacts = [
  '40 visual pages',
  '12 complete 40-minute lessons',
  'Beginner badminton for ages 9–12',
  '12 rackets, 24 shuttlecocks and floor markers',
  'Safe practice space with marked areas',
  '30-minute alternative and a six-racket rotation plan',
];

export const offerCoreInclusions = [
  '40-page visual PDF guide',
  '12 complete 40-minute lessons',
  'Court and station diagrams',
  'Timings and ready-to-say instructions',
  'Easier and harder options',
  '12 printable challenge cards and progress tools',
  'Yours to reuse every school year',
];

export const optionalExtras = ['30 Badminton Practice Games ($9)', 'The Next 12 Lessons ($17)', 'After-School Badminton Club Kit ($27)'];



